var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.162c5.425 0 9.838 4.413 9.838 9.838 0 5.425-4.413 9.838-9.838 9.838-5.425 0-9.838-4.413-9.838-9.838 0-5.425 4.413-9.838 9.838-9.838zm0-1.968C5.48.194.194 5.48.194 12S5.48 23.806 12 23.806 23.806 18.52 23.806 12 18.52.194 12 .194zm-2 15.751c.555-1.76 1.606-3.868 1.791-4.401.269-.775-.207-1.118-1.711.205l-.335-.63c1.716-1.866 5.249-2.288 4.046.604-.75 1.805-1.287 3.024-1.594 3.965-.448 1.37.682.814 1.79-.208.15.246.199.326.35.609-2.458 2.34-5.186 2.546-4.337-.144zm4.665-8.037c-.523.446-1.299.436-1.732-.021-.434-.458-.361-1.189.16-1.634.524-.446 1.3-.435 1.733.021.432.459.362 1.19-.16 1.635z",
    fill: "#8cabca"
  })));
}
export default SvgInfoinline;